import axios from 'axios'

export default {
    get: () => axios.get('events-classes'),
    store: (data) => axios.post('events-classes/store', data),
    update: (data) => axios.post('events-classes/update', data),
    delete: (id) => axios.post('events-classes/delete', id)
}